/**
 * Array of all valid campaign include relations
 * Used for runtime validation
 */
export const VALID_CAMPAIGN_RELATIONS = [
    'triggerSources',
    'businesses',
    'claimCount',
    'ownerBusiness'
];
/**
 * Type guard to validate campaign include relation at runtime
 *
 * @param value - String to validate
 * @returns True if value is a valid CampaignIncludeRelation
 */
export function isValidCampaignRelation(value) {
    return VALID_CAMPAIGN_RELATIONS.includes(value);
}
//# sourceMappingURL=campaign-include-relation.type.js.map